import React from 'react';
import {
  TableHead,
  TableRow,
  TableCell,
} from '../../../../../../components/customTableComponents';
import CheckboxCell from '../CheckboxCell/CheckboxCell';
import { columns } from '../../constants/columns';
import { checkboxCellWidth } from '../../constants/common';
import styles from './Head.module.scss';
import SortDone from './SortDone/SortDone';
import SortableHeader from '../SortableHeader/SortableHeader';
import SortStagesLife from './SortStagesLife/SortStagesLife';

const Head = ({
  onSelectAllClick,
  numSelected,
  rowCount,
  checkboxDisabled = false,
  sortConfig,
  handleSort,
  onExtraSort,
  showInLifeCirle,
}) => {
  return (
    <TableHead>
      <TableRow>
        {typeof onSelectAllClick === 'function' && rowCount > 0 ? (
          <CheckboxCell
            style={{
              width: `${checkboxCellWidth}px`,
            }}
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            component="th"
            disabled={checkboxDisabled}
          />
        ) : (
          <TableCell
            padding="empty"
            component="th"
            style={{
              width: `${checkboxCellWidth}px`,
            }}
          />
        )}
        {columns.map((column) => (
          <TableCell
            component="th"
            key={column.key}
            style={{
              width: column.width,
              cursor: column.sort ? 'pointer' : null,
            }}
            onClick={column.sort ? () => handleSort(column.key) : undefined}
          >
            <div className={styles.contentWrap}>
              <p className={styles.content}>{column.title}</p>
              {column.key === 'done' && (
                <SortDone
                  onSort={onExtraSort}
                  sortConfig={sortConfig}
                />
              )}
              {column.key === 'num/create' && showInLifeCirle && (
                <SortStagesLife
                  onSort={onExtraSort}
                  sortConfig={sortConfig}
                />
              )}

              {column.sort && (
                <SortableHeader
                  sortOrder={sortConfig?.order}
                  columnTrue={sortConfig?.key === column.key}
                />
              )}
            </div>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default Head;
